var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-outline",attrs:{"tabindex":"0"}},[(_vm.loaded)?_c('main',{staticClass:"main-view no-top-panel"},[_c('SummaryComponent',{attrs:{"infos":_vm.infos,"checklists":_vm.checklists},on:{"back":_vm.toDashboard,"print":_vm.toPrint}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }